import { action, observable, runInAction, makeObservable } from 'mobx';
import Student from '@home/model/Student'
import { request } from '@/framework/network/request'
import {TablePaginationConfig} from 'antd/lib/table'
import { Key, SorterResult, TableCurrentDataSource } from 'antd/lib/table/interface'


export default class TableLayoutStore {
  loading:boolean;
  studentData:Array<Student>;
  pagination:TablePaginationConfig;
  filters:Record<string, (Key | boolean)[] | null>;
  sorter:SorterResult<Record<any,any>> | SorterResult<Record<any,any>>[];
  tableSearch: object;
  tableSelectedRowKeys:Array<any>;
  tableSelectedRows:Array<any>;
  drawerVisible:boolean;

  constructor () {
    // console.log("constructor")
    makeObservable(this, {
      loading: observable,
      studentData: observable,
      pagination: observable,
      filters: observable,
      sorter: observable,
      tableSearch: observable,
      tableSelectedRowKeys: observable,
      tableSelectedRows: observable,
      drawerVisible: observable,
      getStudentData: action,
      tableOnChange: action,
      tableToolBarOnSearch: action,
      setTableSelectedRowKeys: action,
      setOpenDrawerVisible: action,
      setClosedDrawerVisible: action
    });

    this.loading = false
    this.studentData = []
    this.pagination = {}
    this.filters = {}
    this.sorter = {}
    this.tableSearch = {}
    this.tableSelectedRowKeys = []
    this.tableSelectedRows = []
    this.drawerVisible = false
  }


  getStudentData = async (page:number = 0,size:number = 10) => {
    this.loading = true
    try {
      const res = await request.get('/sd/student:search',{page: page, size: size,...this.tableSearch })
      runInAction(()=>{
        this.studentData = res.data.content
        this.pagination = {
          ...this.pagination,
          total: res.data.totalElements,
          current: res.data.number + 1,
          pageSize: res.data.size,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100']
        }
        this.loading = false
      })

    }catch (error){
      console.warn(error)
      runInAction(()=>{
        this.loading = false
      })
    }
  };

  tableOnChange = (pagination:TablePaginationConfig, filters:Record<string, (Key | boolean)[] | null>, sorter:SorterResult<Record<any,any>> | SorterResult<Record<any,any>>[], extra:TableCurrentDataSource<Record<any, any>>) => {
    const page = pagination.current&& pagination.current-1
    this.tableSelectedRowKeys = []
    this.tableSelectedRows = []
   this.getStudentData(page,pagination.pageSize)
  };
  tableToolBarOnSearch = (keyWord:string) => {
    this.tableSearch = {name_li:keyWord}
    this.getStudentData()
  };
  setTableSelectedRowKeys = (selectedRowKeys:Array<any>,selectedRows:Array<any>) => {
    this.tableSelectedRowKeys = selectedRowKeys
    this.tableSelectedRows = selectedRows
  };

  setOpenDrawerVisible = (type:"add"|"modify"|"info"|"del") => {
    this.drawerVisible = true
  };
  setClosedDrawerVisible = () => {
    this.drawerVisible = false
  };
}
